import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

interface Props {
  children: ReactElement;
}

const ProtectedRoute = ({ children }: Props) => {
  const { user, loading } = useAuth();

  // Show loading state while Firebase auth is initializing
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="h-8 w-8 rounded-md bg-primary animate-pulse mb-2 mx-auto"></div>
          <span className="font-bold text-xl">Zuto</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute; 